import { useData } from '@virtual-care/ui';

export function useSpecialities() {
  return useData(
    'GET /specialities',
    { pageSize: 100 },
    { staleTime: 1000 * 60 * 60 * 24 }, // 24 hours
  );
}
